import { FunctionComponent, JSX } from 'react'
import styles from './messageWithURL.module.scss'

interface MessageWithURLProps {
    message: string
}

const MessageWithURL: FunctionComponent<MessageWithURLProps> = ({ message }: MessageWithURLProps): JSX.Element => {
    const urlRegex: RegExp = /(https?:\/\/[^\s]+|www\.[^\s]+)/g
    const parts: string[] = message.split(urlRegex)

    return (
        <div className={styles.Text}>
            {parts.map((part: string, index: number): JSX.Element => {
                if (part.match(urlRegex)) {
                    const href: string = part.startsWith('www.') ? `https://${part}` : part

                    return (
                        <a
                            key={index}
                            href={href}
                            target='_blank'
                            rel='noopener noreferrer'
                            className={styles.TextLink}
                        >
                            {part}
                        </a>
                    )
                }
                return <span key={index}>{part}</span>
            })}
        </div>
    )
}

export default MessageWithURL
